import { ServiceLocation, Site } from '@iss/libs/graphql';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { DetailsBoxComponent } from '../details-box';

@Component({
  selector: 'wo-site-with-service-location',
  templateUrl: './site-with-service-location.component.html',
  styleUrls: [ './site-with-service-location.component.scss' ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    DetailsBoxComponent,
  ],
})
export class SiteWithServiceLocationComponent {
  @Input({ required: true }) site!: Site['name'];
  @Input({ required: true }) serviceLocation!: ServiceLocation['name'];
}
